import { Component, OnInit } from '@angular/core';
import { TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import { AimsHub } from '../../../../../src/app/components/aimsHub/aimsHub';
import { HrEmployees } from 'src/models';
import * as moment from 'moment-mini';
import { map } from 'rxjs/operators';
import { AimsCommonTableHeader, AimsCommonTablePermissions } from '@aims/common-components';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-scheduler-action-required',
  templateUrl: './scheduler-action-required.component.html',
  styleUrls: ['./scheduler-action-required.component.scss'],
  providers: [AimsHub]
})
export class SchedulerActionRequiredComponent implements OnInit {

  constructor(private transferHttp: TransferHttpService,
    public permissions: PermissionsService,
    public schrActionRequiredHub: AimsHub) { }

  // AimsCommonTable setup
  tablePermissions: Observable<AimsCommonTablePermissions> = this.permissions.getDataGridPerms$(
    this.permissions.ComponentID.SchedulerActionRequired, 
    { create: false, update: false, export: false, delete: false });
  tableHeader: AimsCommonTableHeader[] = [
    { key: 'details', label: 'Details', type: 'detailsButton', prefix: '/scheduling/', linkId: 'scheduleItemId', filter: false, },
    { key: 'travelerFullName', label: 'Traveler', type: 'string', width: 300, },
    { key: 'siteName', label: 'Site', type: 'string', },
    { key: 'jobTitle', label: 'Job Title', type: 'string', },
    { key: 'scheduleItemStart', label: 'Start', type: 'date', },
    { key: 'scheduleItemEnd', label: 'End', type: 'date', },
    { key: 'scheduleItemId', label: 'Schedule Item Id', type: 'number', },
    { key: 'scheduleItemType', label: 'SI Type', type: 'string', },
    { key: 'scheduleItemStatus', label: 'SI Status', type: 'string', },
  ];

  m = moment;
  user = this.transferHttp.getCache<HrEmployees>('user');

  //Grid
  public schrActionRequired = this.schrActionRequiredHub.getHot('schrActionRequired').pipe(
    map(oArr => oArr.map(o => {
      return {
        travelerFullName: o.travelerFullName,
        siteName: o.siteName,
        jobTitle: o.jobTitle,
        scheduleItemStart: moment(o.scheduleItemStart).toDate(),
        scheduleItemEnd: moment(o.scheduleItemEnd).toDate(),
        scheduleItemId: o.scheduleItemId,
        scheduleItemType: o.scheduleItemType,
        scheduleItemStatus: o.scheduleItemStatus
      }
    })
    )
  );

  ngOnInit() {
  }
}
